import { render, staticRenderFns } from "./CreditModelAssessmentModal.vue?vue&type=template&id=bddf12a0&scoped=true"
import script from "./CreditModelAssessmentModal.vue?vue&type=script&lang=js"
export * from "./CreditModelAssessmentModal.vue?vue&type=script&lang=js"
import style0 from "./CreditModelAssessmentModal.vue?vue&type=style&index=0&id=bddf12a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bddf12a0",
  null
  
)

export default component.exports